var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutputsShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8022_9823)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8022_9823",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8022_9823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8022_9823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6172 4.8771C10.8988 4.8771 11.1278 5.1066 11.1278 5.3888V9.6281C11.1278 9.9102 10.8988 10.1398 10.6172 10.1398H6.3861C6.1045 10.1398 5.8754 9.9102 5.8754 9.6281V5.3888C5.8754 5.1066 6.1045 4.8771 6.3861 4.8771H10.6172ZM10.6172 4H6.3861C5.6201 4 5 4.6213 5 5.3888V9.6281C5 10.3956 5.6201 11.0169 6.3861 11.0169H10.6172C11.3832 11.0169 12.0032 10.3956 12.0032 9.6281V5.3888C12.0032 4.6213 11.3832 4 10.6172 4ZM10.6478 12.8602C10.9294 12.8602 11.1585 13.0898 11.1585 13.3719V17.6112C11.1585 17.8934 10.9294 18.1229 10.6478 18.1229H6.4167C6.1351 18.1229 5.9061 17.8934 5.9061 17.6112V13.3719C5.9061 13.0898 6.1351 12.8602 6.4167 12.8602H10.6478ZM10.6478 11.9831H6.4167C5.6508 11.9831 5.0307 12.6044 5.0307 13.3719V17.6112C5.0307 18.3787 5.6508 19 6.4167 19H10.6478C11.4138 19 12.0339 18.3787 12.0339 17.6112V13.3719C12.0339 12.6044 11.4138 11.9831 10.6478 11.9831ZM18.5848 12.8602C18.8663 12.8602 19.0954 13.0898 19.0954 13.3719V17.6112C19.0954 17.8934 18.8663 18.1229 18.5848 18.1229H14.3537C14.0721 18.1229 13.843 17.8934 13.843 17.6112V13.3719C13.843 13.0898 14.0721 12.8602 14.3537 12.8602H18.5848ZM18.5848 11.9831H14.3537C13.5877 11.9831 12.9676 12.6044 12.9676 13.3719V17.6112C12.9676 18.3787 13.5877 19 14.3537 19H18.5848C19.3507 19 19.9708 18.3787 19.9708 17.6112V13.3719C19.9708 12.6044 19.3507 11.9831 18.5848 11.9831ZM15.1196 6.9412C15.1868 7.0626 15.3108 7.1371 15.445 7.1342L15.8229 7.1254C15.8185 8.1151 15.7193 9.305 13.9845 10.3327L13.9641 10.3444L13.9481 10.3605C13.878 10.4321 13.8547 10.5301 13.8912 10.6178C13.9291 10.7069 14.0239 10.7654 14.1261 10.764H14.1407L14.1553 10.761C15.0117 10.6119 15.7485 10.3532 16.351 9.9877C16.8573 9.6807 17.2717 9.2977 17.581 8.8489C18.0654 8.1487 18.185 7.4602 18.2098 7.0757L18.6417 7.067C18.8036 7.064 18.9451 6.9807 19.0181 6.8448C19.0881 6.7132 19.0794 6.5553 18.9947 6.4325L18.9904 6.4252L17.5241 4.4619C17.4176 4.326 17.2556 4.25 17.0776 4.2529C16.9609 4.2558 16.8515 4.2909 16.7596 4.3552C16.7114 4.3889 16.6662 4.4312 16.6282 4.4809L15.143 6.5071L15.1401 6.5144C15.054 6.6445 15.0452 6.8082 15.1196 6.9412Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8022_9823",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8022_9823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutputsShort);
export default __webpack_public_path__ + "static/media/Outputs-Short.3b770296148407ad5484bbd74ba595ee.svg";
export { ForwardRef as ReactComponent };